import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['thumbnail', 'iframe', 'modal', 'fromDashboard'];

  connect() {
    this.#initializeModal();
    this.element.addEventListener('hidden.bs.modal', () => {
      this.#pauseVideo();
    });
  }

  #initializeModal() {
    const youtubeIframeUrl = 'https://www.youtube.com/embed/';

    if (
      this.hasFromDashboardTarget &&
      this.fromDashboardTarget.dataset.fromDashboardTitle
    ) {
      this.#showModalAndUpdateInfo(
        youtubeIframeUrl,
        this.fromDashboardTarget.dataset.fromDashboardYoutubeId,
        this.fromDashboardTarget.dataset.fromDashboardTitle,
        this.fromDashboardTarget.dataset.fromDashboardCategory
      );
    }

    this.thumbnailTargets.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        this.#showModalAndUpdateInfo(
          youtubeIframeUrl,
          thumbnail.dataset.youtubeId,
          thumbnail.dataset.title,
          thumbnail.dataset.category
        );
      });
    });
  }

  #showModalAndUpdateInfo(youtubeIframeUrl, youtubeId, title, category) {
    new bootstrap.Modal(this.modalTarget).show();
    this.#updateIframe(youtubeIframeUrl, youtubeId);
    this.#updateReplayInfo(title, category);
  }

  #updateIframe(youtubeIframeUrl, youtubeId) {
    const newIframeSrc = this.#constructIframeSrc(youtubeIframeUrl, youtubeId);
    if (this.iframeTarget.src !== newIframeSrc) {
      this.iframeTarget.src = newIframeSrc;
    }
  }

  #constructIframeSrc(youtubeIframeUrl, youtubeId) {
    return `${youtubeIframeUrl}${youtubeId}?enablejsapi=1`;
  }

  #updateReplayInfo(title, category) {
    document.getElementById('replayTitle').innerText = title;
    document.getElementById('replayCategory').innerText = category;
  }

  #pauseVideo() {
    this.iframeTarget.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      '*'
    );
  }
}
